import { Coordinate } from '../navigation/coodinate';
import { ParsedDate } from '../parsed/parsedDate';
import { ParsedNumber } from '../parsed/parsedNumber';
import { PriceDetails } from '../product/priceDetails';
import { BasketItemMetaData } from './basketItemMetadata';
import { z } from 'zod';

export const BasketItemProduct = z.object({
    itemId: z.string().nullish(),
    rootItemId: z.string().nullish(),
    gtin: z.string().nullish(),
    gtins: z.string().array().nullish(),
    brand: z.string().nullish(),
    name: z.string().nullish(),
    age: z.number().nullish(),
    negativePos: z.boolean().nullish(),
    commodityGroupId: z.string().nullish(),
    cgLongId: z.string().nullish(),
    itemClassCode: z.string().nullish(),
    isWeightProduct: z.boolean().nullish(),
    isDiscountable: z.boolean().nullish(),
    capacity: z.number().nullish(),
    x: z.number().nullish(),
    y: z.number().nullish(),
    positions: Coordinate.array().nullish(),
    isInSpecialityMarket: z.boolean().nullish(),
    forceActive: z.boolean().nullish(),
    tooLight: z.boolean().nullish(),
    tooHeavy: z.boolean().nullish(),
    toBeCollected: z.boolean().nullish(),
    noBarcodeTopic: z.string().nullish(),
    weight: z.number().nullish(),
    disableRemovalFromBasket: z.boolean().nullish(),
    hasImage: z.boolean().nullish(),
    allowOnlySinglePosTransfer: z.boolean().nullish(),
    disableDiscountCodes: z.string().array().nullish(),
    isStoreBrand: z.boolean().nullish(),
    cgIcon: z.string().nullish(),
    cgLocalKey: z.string().nullish(),
    bundleRefItemId: z.string().nullish(),
    contents: z.any().nullish(),
    boonuspoints: z.boolean().nullish(),
    taxPercent: z.unknown(),
    networks: z.array(z.string()).nullish(),
    salesLimitQty: z.number().nullish(),
    tags: z.array(z.string()).nullish(),
});
export type BasketItemProduct = z.infer<typeof BasketItemProduct>;

export const BasketItem = z.object({
    createdOn: ParsedDate.nullish(),
    modifiedOn: ParsedDate.nullish(),
    deletedOn: ParsedDate.nullish(),
    priceDetails: PriceDetails.nullish(),
    basketItemGuid: z.string(),
    sessionGuid: z.string(),
    scannedCode: z.string(),
    scannedCodeType: z.string().nullish(),
    itemSource: z.string().nullish(),
    changeSource: z.string().nullish(),
    discountCode: z.string().nullish(),
    classificationType: z.string().nullish(),
    amount: z.number(),
    minAmount: z.number().optional(),
    maxAmount: z.number().optional(),
    isPriceEncoded: z.boolean().nullish(),
    product: BasketItemProduct.nullish(),
    bundles: BasketItemProduct.array().nullish(),
    discountInfo: z
        .object({
            code: z.string(),
            discountPercentage: z.number().nullish(),
            discountValue: z.number().nullish(),
            showSticker: z.boolean().nullish().nullish(),
        })
        .nullish(),
    flags: z.string().array(),
    total: z.number(),
    totalPrice: z.number().nullish(),
    payableLineTotalWithoutDiscounts: z.number().nullish(),
    payablePosOriginalTotal: z.number().nullish(),
    payablePosTotal: z.number().nullish(),
    payableTotal: z.number().nullish(),
    posTotal: z.number().nullish(),
    posOriginalTotal: z.number().nullish(),
    posAmount: z.number().nullish(),
    posFailedReason: z.unknown(),
    awaitingPos: z.boolean().nullish(),
    scores: z
        .object({
            global: ParsedNumber.nullish(),
            store: ParsedNumber.nullish(),
        })
        .nullish(),
    basketMetadataList: BasketItemMetaData.array(),
});
export type BasketItem = z.infer<typeof BasketItem>;
